<template>
  <div class="row">
    <div class="sixteen wide column">
      <div style="font-size: 1.25rem">
        <span v-html="title"/>
        <div
          v-if="subtitle !== null"
          class="subtitle"
          v-html="subtitle"/>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'QuestionTitle',
  props: {
    title: {
      type: String,
      required: true
    },
    index: {
      type: Number,
      required: false,
      default: () => {
        return 1
      }
    },
    subtitle: {
      validator: (prop) => {
        return (typeof (prop) === 'string' || prop === null)
      },
      required: false,
      default: () => {
        return null
      }
    }
  }
}
</script>

<style scoped>
.subtitle {
  font-size: 1.25rem;
  font-style: italic;
  color: rgb(169, 169, 169);
}
</style>
